// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import store from './store/index.js'
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';

import api from './api/api.js'

import router from './router'
import './style/theme/index.css'

import dataFormat from './utils/dataFormat.js'
import BaiduMap from 'vue-baidu-map'

import VueCookies from 'vue-cookies'
import utils from './utils'
import animated from 'animate.css' // npm install animate.css --save安装，在引入

Vue.use(animated)

Vue.use(VueCookies)

Vue.use(BaiduMap, {
  ak: 'tExE2rsgjVj5kO2VQa0lwq8uUGS4dkw1'
})

Vue.use(ElementUI);

Vue.prototype.$api = api;
Vue.prototype.$db = utils.db;
Vue.prototype.$user = utils.user;
Vue.prototype.$dataFormat = dataFormat;

Vue.config.productionTip = false;
// Vue.Cancel = [];
router.beforeEach((to, from, next) => {
    // while (Vue.Cancel.length > 0) {
    //     Vue.Cancel.shift()('cancel');
    // }
  document.title = to.matched[0].meta.title;
    if (to.meta.requireAuth) {
        // 需要登录的页面
        if (sessionStorage.getItem('sid') || $cookies.get('sid')) {
            next()
        } else {
            next('/login')
        }
        // // 需要登录的页面
		// if (VueCookies.get('is-login') != null && VueCookies.get('is-login') == 'true') {
		// 	next()
		// }else {
		// 	next('/login')
		// }
    } else {
        // 不需要登录的页面
        if (to.name === 'login') {
            // login页面特殊处理
            if (sessionStorage.getItem('sid')) {
              if(to.query.from_url || to.query.from_type) {
                // 清空原登录态, 重新登录
                const vm = Vue.prototype
                vm.$user.logout(() => {
                  vm.$db.local.remove('company')
                  vm.$db.local.remove('warehouseList')
                  next()
                })
              } else {
                // 若已存在sid即已登录
                next('/index')
              }
            } else {
                next()
            }
            // if (VueCookies.get('is-login') != null && VueCookies.get('is-login') == 'true') {
            //     // 若已存在sid即已登录
            //     next('/manager')
            // } else {
            //     next()
            // }
        } else {
            next()
        }
    }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js